import { Injectable } from '@angular/core'

import { IEntityListConfig, Utils } from './../../'

@Injectable()
export class EntityListRegistryService {

  private _configRegistry: Map<string, IEntityListConfig> = new Map<string, IEntityListConfig>()

  constructor(entityListConfigs: IEntityListConfig[], private _utils: Utils) {
    this._registerConfigs(entityListConfigs)
  }

  public getConfig(modelType: string): IEntityListConfig {
    const key = this._keyStrategy(modelType)
    if (! this._configRegistry.has(key)) {
      throw new Error(`No entity view mapping for "${modelType}" found!`)
    }
    return this._configRegistry.get(key)
  }

  private _registerConfigs(entityListConfigs: IEntityListConfig[]) {
    entityListConfigs.forEach((config: IEntityListConfig) => {
      const normalizedConfig = this._normalizeConfig(config)
      const key = this._keyStrategy(normalizedConfig.displayedClass.modelType)
      this._configRegistry.set(key, normalizedConfig)
    })
  }

  private _keyStrategy(key: string) {
    return this._utils.pascalCase(key)
  }

  private _normalizeConfig(config: IEntityListConfig): IEntityListConfig {
    const defaultConfigs = {
      optionsCallback: () => {}
    }
    return Object.assign({}, defaultConfigs, config)
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/services/entity-list-registry/entity-list-registry.service.ts